import { gql } from "urql";
export const GetPresignedImageUrlQuery = gql `
    mutation GetPresignedImageUrl($input: PresignedUrlInput!) {
        images {
            presignedUrl(input: $input) {
                presignedUrl
            }
        }
    }
`;
export const GetImageDetailsQuery = gql `
    mutation GetImageDetails(
        $imagePrefix: ImagePrefixEnum!
        $imageKey: String!
    ) {
        images {
            imageDetails(imagePrefix: $imagePrefix, imageKey: $imageKey) {
                imageKey
                imageVersion
            }
        }
    }
`;
